export default __webpack_public_path__ + "static/media/SharkOutline.90a22816.png";